module.exports = __webpack_public_path__ + "static/vimy-memorial-nov-11-dc5f734913ab943913000ac74c9a9268.jpg";